module.exports = __webpack_public_path__ + "img/sv6on.0866a12f.svg";